<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        :title="$t('storeList.add.dialogTitle_edit')"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="editForm" :model="editForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('storeList.add.platform_id')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.add.selectPlaceholder'
                                    )}${$t('storeList.add.platform_id')}`,
                                },
                            ]"
                            prop="platform_id"
                            size="small"
                        >
                            <img
                                class="store-img"
                                :style="{
                                    width:
                                        this.tableItem.platform_id == 4
                                            ? '30px'
                                            : '',
                                }"
                                :src="storeImgSrc"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('storeList.add.name')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.add.inputPlaceholder'
                                    )}${$t('storeList.add.name')}`,
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'storeList.add.inputPlaceholder'
                                )}${$t('storeList.add.name')}`"
                                maxlength="100"
                                size="small"
                                v-model="editForm.name"
                            >
                            </el-input> <el-tooltip class="item" effect="light" content="Store name may be used for order filtering." placement="right"><i class="el-info el-icon-info"></i></el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item 
                        :label="$t('storeList.add.shop_url')" 
                        :rules="[
                            {
                                required: true,
                                message: 'Please input Shop Url',
                            },
                        ]"
                        prop="shop_url"
                        size="small">
                            <el-input
                                clearable
                                placeholder="Please input Shop Url"
                                maxlength="100"
                                v-model="editForm.shop_url"
                                size="small"
                            >
                                <template slot="prepend">https://</template>
                                <template slot="append" v-if="[3,4,8,9].includes(tableItem.platform_id)">.{{{3:'myshopify',4:'myshoplaza',8:'myshopline',9:'etsy'}[tableItem.platform_id]}}.com</template>
                            </el-input>
                            <el-tooltip class="item" effect="light" content="Make sure store url is correct before authorization." placement="right"><i class="el-info el-icon-info"></i></el-tooltip>
                        </el-form-item>
                    </el-col>
                    <template v-if="[3,4,8,9].includes(tableItem.platform_id)">
                    <el-col :span="24">
                        <el-form-item label="Sync Order" size="small">
                            <el-radio-group v-model="editForm.sync_order">
                            <el-radio label="1">Yes</el-radio>
                            <el-radio label="0">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="App Type" size="small">
                            <el-radio-group v-model="editForm.auth_type">
                            <el-radio label="3">App</el-radio>
                            <el-radio label="1" v-if="tableItem.platform_id === 3">Private</el-radio>
                            <el-radio label="2" v-if="tableItem.platform_id === 3">Custom</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="editForm.auth_type == '1'">
                        <el-form-item
                            label="Appid"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Appid',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Appid"
                                maxlength="100"
                                size="small"
                                v-model="editForm.appid"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="editForm.auth_type == '1'">
                        <el-form-item
                            label="Secret"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Secret',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Secret"
                                maxlength="100"
                                size="small"
                                v-model="editForm.secret"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="editForm.auth_type == '2'">
                        <el-form-item
                            label="Access Token"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input Access Token',
                                },
                            ]"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder="Please input Access Token"
                                maxlength="100"
                                size="small"
                                v-model="editForm.access_token"
                            ></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <h3 style="padding: 10px 0 20px 0;">Customized Option <el-tooltip class="item" effect="light" content="Make sure store url is correct before authorization." placement="right"><i class="el-info el-icon-info"></i></el-tooltip></h3>
                    </el-col>
                    
                    <el-col :span="24">
                        <el-form-item class="customized" label="Customized Field" size="small">
                            <el-radio-group v-model="editForm.customized">
                            <el-radio label="1">Yes</el-radio>
                            <el-radio label="0">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item
                            class="customized"
                            label="Customized Field Language"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'storeList.add.selectPlaceholder'
                                    )}${$t('storeList.add.language')}`,
                                },
                            ]"
                            size="small"
                            prop="lang"
                        >
                            <el-select
                                v-model="editForm.lang"
                                size="mini"
                                placeholder="Please select"
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="item in languages"
                                    :key="item.id"
                                    :label="item.lang"
                                    :value="item.code"
                                ></el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    </template>                  
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save(1)"
                :loading="authLoading"
                v-if="[3,4,8,9].includes(tableItem.platform_id) && editForm.auth_type == 3"
            >Authorize</el-button>
            <el-button
                size="small"
                type="primary"
                @click="save(0)"
                :loading="loading"
                >{{ $t("storeList.add.save") }}</el-button
            >
            <el-button size="small" @click="editVisible = false">{{
                $t("storeList.add.close")
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                platform_id: "",
                shop_url: "",
                sync_order: "1",
                auth_type: "3",
                appid: "",
                secret: "",
                access_token: "",
                customized:"1",
                track_id: "",
                customer_ids: [],
                customer_email: "",
                lang:"en",
                type:0
            },
            platformList: [],
            languages:[],
            tableItem: {},
            httpList: ["https://", "http://"],
            loading: false,
            authLoading:false,
            storeImgSrc: ""
        };
    },
    methods: {
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                    this.platformList.map((item) => {
                        if (this.tableItem.platform_id == item.id) {
                            this.storeImgSrc = require(`@/assets/image/goods/${item.code}.png`);
                        }
                    });
                }
                this.loading = false;
            });
        },
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.editForm = {
                name: "",
                platform_id: "",
                shop_url: "",
                sync_order: "0",
                app_type: "3",
                auth_type: "3",
                appid: "",
                secret: "",
                access_token: "",
                customized:"1",
                track_id: "",
                customer_ids: [],
                customer_email: "",
                lang:"en",
                type:0
            };
            this.tableItem = {};
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        /**
         *  保存
         */
        save(type) {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    if(type == 0){
                        this.loading = true;
                    }else{
                        this.authLoading = true;
                    }
                    this.editForm.type = type;
                    
                    cmofferApi
                        .shop({ ...this.editForm }, "post", this.tableItem.id)
                        .then((res) => {
                            if (res) {
                                if(type == 1){
                                    res.data.status && window.open(res.data.url);
                                    this.$confirm(
                                        "Whether the store has been authorized.",
                                        "Authorization status",
                                        {
                                            confirmButtonText: "Success",
                                            cancelButtonText: "Fail",
                                            customClass: "auth-message-box",
                                        }
                                    )
                                        .then(() => {
                                            this.$parent.shop && this.$parent.shop();
                                            this.closeDialog();
                                        })
                                        .catch(() => { });
                                }else{
                                    this.$message.success(
                                        this.$i18n.locale == "zh"
                                            ? "修改成功"
                                            : "Success"
                                    );
                                    this.$parent.shop && this.$parent.shop();
                                    this.$parent.$parent && this.$parent.$parent.myStoreList && this.$parent.$parent.myStoreList(1,this.tableItem.user_id);
                                    this.closeDialog();
                                }
                                
                            }
                            if(type == 0){
                                this.loading = false;
                            }else{
                                this.authLoading = false;
                            }
                        });
                }
            });
        },
        /**
         * 获取详情
         */
        getShop() {
            cmofferApi.shop({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.editForm = res.data;
                    this.languages = res.data.languages;
                }
            });
        },
        async initialize() {
            this.loading = true;
            await this.platformSelect();
            await this.getShop();
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
    },
    computed: {
        mixed() {
            const { tableItem, editVisible } = this;
            return {
                tableItem,
                editVisible,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                this.tableItem = newValue.tableItem;
                if (newValue.editVisible) {
                    this.initialize();
                }
            },
            deep: true,
            immediate: false,
        },
    },
};
</script>
<style lang="scss">
.edit {
    .el-form-item__content {
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
        .el-input{
            padding-right: 10px;
            width: calc(100% - 50px);
        }
        .el-input-group__prepend, .el-input-group__append {
            border-radius: 0;
            padding: 0 7px !important;
            // color: #666;
            text-align: center;
        }
        .store-img {
            width: 85px;
            position: absolute;
        }
        .el-input__suffix {
            right: 12px;
        }
    }
    .form-label__icon{
        font-weight: 600;
        margin: 0 0 0 4px;
        color: $color-primary;
    }
    .el-col {
        padding-left: 20px!important;
        padding-right: 20px!important;

        .el-info {
            font-size: 18px;
            &.check {
                color: $color-primary;
            }
        }
        .customized {
            .el-form-item__label {
                width: auto!important;
            }
        }
    }
}
</style>
